import React from 'react';
import { Skeleton } from '@heroui/react';
import { cn } from '@/utils/cn';

interface UserCardSkeletonProps {
  className?: string;
}

const UserCardSkeleton: React.FC<UserCardSkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'rounded-2xl border border-gray-200/60 dark:border-gray-800/60',
        'bg-white dark:bg-gray-900',
        'shadow-sm',
        'flex flex-col h-full',
        className
      )}
    >
      {/* Decorative gradient header skeleton */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100/50 to-gray-200/50 dark:from-gray-800/50 dark:to-gray-700/50" />
        <div className="relative p-6 pb-8">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1 min-w-0 pr-2">
              <Skeleton className="mb-3 h-7 w-3/4 rounded-lg bg-white/30" />
              <Skeleton className="h-4 w-full rounded-lg bg-white/30" />
            </div>
            <Skeleton className="w-12 h-12 rounded-xl flex-shrink-0 bg-white/30" />
          </div>
          <div className="flex justify-center mb-4">
            <Skeleton className="w-24 h-24 rounded-full ring-4 ring-white/50 dark:ring-gray-800/50 bg-white/30" />
          </div>
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-6 w-20 rounded-full bg-white/30" />
          </div>
        </div>
      </div>

      {/* Content skeleton */}
      <div className="p-6 flex-1 flex flex-col bg-gradient-to-b from-white to-gray-50/50 dark:from-gray-900 dark:to-gray-950/50">
        <div className="flex-1" />
      </div>
    </div>
  );
};

export default UserCardSkeleton;

